var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 481,
    height: 436,
    viewBox: "0 0 481 436",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_product_hunt_n-3-f5 1",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M227.093 201.128C227.069 200.239 227.054 199.36 227.046 198.492C226.969 192.817 227.472 187.149 228.546 181.589C228.714 180.79 228.899 180.01 229.125 179.248C232.212 174.093 235.878 164.796 236.203 155.807L278.724 86.7761L256.797 31.293L256.49 30.826C255.402 25.5542 251.162 9.60355 240.066 11.6005C228.274 13.7202 238.797 32.786 241.293 37.0194C241.606 37.554 241.797 37.8489 241.797 37.8489L241.936 37.7998V37.8489H241.786L253.821 84.6317C252.714 87.6424 241.212 118.321 228.813 128.6C228.691 112.539 230.33 92.054 230.996 84.4351C231.244 81.7449 231.048 79.0293 230.417 76.4106C226.983 62.4753 214.78 52.1713 200.226 52.1713C196.304 52.1699 192.416 52.9386 188.758 54.4386C182.685 56.9408 177.543 61.4708 174.109 67.3451C170.675 73.2194 169.135 80.1192 169.721 87.0034C170.474 95.9495 171.841 113.94 171.94 128.232C158.799 117.645 146.584 83.8083 146.584 83.8083L158.7 37.8489C158.7 37.8489 173.7 13.9844 160.438 11.6005C149.26 9.59126 145.038 25.7877 143.99 30.9427L143.706 31.889L121.773 86.1801L165.169 156.588C165.279 163.807 167.486 171.752 171.974 179.254C172.399 179.968 172.688 180.763 172.826 181.595C172.875 181.875 172.91 182.158 172.93 182.443C172.704 186.744 169.907 192.077 166.768 197.933C164.555 202.056 162.187 206.43 160.432 210.866C156.378 221.084 154.472 226.842 154.565 235.444C154.449 245.846 157.461 260.193 163.316 292.586C166.396 291.232 169.567 290.123 172.803 289.268C174.384 304.119 176.138 324.352 174.54 328.856C172.42 334.908 171.065 364.099 172.108 379.675C165.158 389.205 162.129 388.892 162.129 388.892C154.6 391.282 154.994 396.08 156.598 399.263C157.111 400.558 157.877 401.722 158.845 402.679C159.064 402.878 159.258 403.105 159.424 403.355C159.951 405.321 158.561 408.406 156.291 415.644C155.19 419.158 155.903 422.446 157.223 425.174C159.302 430.132 163.594 433.487 163.594 433.487C168.302 434.98 169.843 433.413 169.826 430.759C171.36 433.874 175.142 436.436 183.679 435.92C183.679 435.92 189.523 436.326 186.575 429.026C183.627 421.727 185.115 392.124 185.115 392.124C185.115 392.124 185.393 388.437 185.857 382.852L226.021 334.558L231.233 289.274C234.569 294.275 236.84 295.738 244.641 296.186C244.641 296.186 244.514 295.762 244.282 294.957H244.641C244.641 294.957 228.135 240.107 227.093 201.128ZM196.976 287.732C199.512 288.207 201.992 288.974 204.372 290.017L204.894 293.194L202.704 332.935C197.801 336.461 193.432 340.758 189.749 345.679C190.641 339.252 191.579 334.342 192.459 332.929C194.631 329.452 196.166 304.352 196.953 287.732H196.976ZM169.843 421.334C169.261 422.962 168.955 424.686 168.94 426.427C168.772 425.948 168.58 425.463 168.36 424.983C167.011 421.739 170.926 410.188 174.152 401.789C173.983 404.816 173.633 407.828 173.104 410.808L169.843 421.334Z",
    fill: "url(#paint0_linear_0_1)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M221.787 242.921H194.104V265.833H221.787V242.921Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M231.361 86.1186C231.607 83.4718 231.427 80.7998 230.828 78.217C229.773 73.853 227.855 69.7772 225.201 66.2605C222.546 62.7437 219.217 59.8665 215.434 57.8202C211.65 55.7738 207.5 54.6052 203.258 54.3918C199.016 54.1785 194.78 54.9254 190.832 56.5829C178.727 61.6827 171.436 74.8745 172.565 88.6378C173.845 104.207 176.949 147.592 171.986 149.516C198.563 139.531 211.855 138.941 231.784 149.516C226.977 141.915 230.342 98.0631 231.361 86.1186Z",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M226.988 97.6638C227.197 95.5707 227.042 93.4548 226.531 91.4212C223.704 80.5826 213.743 72.5643 201.853 72.5643C198.648 72.5572 195.468 73.1521 192.459 74.3215C182.15 78.3522 175.936 88.773 176.897 99.6484C177.986 111.937 180.633 146.228 176.382 147.752C199.021 139.863 210.343 139.396 227.347 147.752C223.259 141.749 226.125 107.077 226.988 97.6638Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M173.706 271.701C173.706 271.701 179.66 319.627 177.181 326.797C174.702 333.968 173.33 374.311 175.779 384.29C178.229 394.268 175.779 407.447 175.779 407.447L172.629 417.825C172.629 417.825 166.675 433.395 185.949 432.197C185.949 432.197 191.556 432.596 188.752 425.438C185.949 418.28 187.351 389.107 187.351 389.107C187.351 389.107 191.202 336.008 194.359 330.816C197.515 325.624 199.264 271.726 199.264 271.726L173.706 271.701Z",
    fill: "#FDB797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.1,
    d: "M166.368 429.014C166.368 429.014 156.911 421.426 159.714 412.246C162.517 403.067 163.918 400.67 161.816 398.673C159.714 396.676 155.509 389.088 165.291 385.899C165.291 385.899 168.766 386.299 176.874 373.924C184.982 361.549 184.229 345.974 204.204 330.803L206.307 291.676L201.737 263.345L233.62 266.141L226.264 331.621L180.013 388.689C180.013 388.689 168.801 415.441 170.903 420.639C173.005 425.837 173.706 431.404 166.368 429.014Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M166.698 429.813C166.698 429.813 157.241 422.224 160.044 413.045C162.847 403.865 164.248 401.469 162.146 399.472C160.044 397.475 155.839 389.887 165.621 386.698C165.621 386.698 169.096 387.097 177.204 374.723C185.312 362.348 184.559 346.772 204.534 331.602L206.637 292.475L202.085 264.125L233.967 266.921L226.6 332.389L180.361 389.488C180.361 389.488 169.148 416.24 171.25 421.438C173.353 426.636 174.059 432.203 166.698 429.813Z",
    fill: "#FDB797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.1,
    d: "M244.49 294.613C234.523 293.999 233.967 291.676 227.88 281.71C221.793 271.744 210.714 280.537 210.714 280.537L206.84 248.23L207.419 289.348C189.702 279.947 166.443 291.111 166.443 291.111C156.453 234.694 155.133 233.852 163.646 211.788C165.438 207.421 167.469 203.168 169.727 199.051C173.237 192.329 176.312 186.283 175.519 181.785C175.388 180.969 175.11 180.187 174.702 179.481C161.075 156.072 169.212 128.262 194.805 132.668C196.108 132.889 196.849 133.073 196.849 133.073H206.816C247.236 130.726 236.718 167.144 229.519 179.481C229.328 180.225 229.149 180.999 228.986 181.785C227.782 187.61 227.394 194.596 227.591 202.197C228.616 240.568 244.49 294.613 244.49 294.613Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M244.49 293.452C234.523 292.838 233.967 290.515 227.88 280.549C221.793 270.583 211.27 279.32 211.27 279.32L206.84 247.013V288.131C189.123 278.73 166.42 289.895 166.42 289.895C156.453 233.502 155.138 232.666 163.652 210.59C165.444 206.223 167.474 201.97 169.733 197.853C173.243 191.131 176.318 185.085 175.525 180.587C175.393 179.771 175.116 178.989 174.708 178.283C161.08 154.873 169.218 127.064 194.81 131.47C196.114 131.691 196.855 131.875 196.855 131.875H206.822C247.241 129.528 236.724 165.945 229.525 178.283C229.334 179.027 229.154 179.801 228.992 180.587C227.788 186.412 227.399 193.398 227.596 200.999C228.616 239.382 244.49 293.452 244.49 293.452Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M194.104 110.745H209.608V136.33C209.608 137.797 209.059 139.203 208.081 140.24C207.104 141.277 205.778 141.86 204.395 141.86H199.345C197.963 141.86 196.637 141.277 195.659 140.24C194.682 139.203 194.133 137.797 194.133 136.33V110.745H194.104Z",
    fill: "#FDB797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    opacity: 0.1,
    d: "M194.104 121.215C199.147 122.92 204.565 122.92 209.608 121.215V111.925H194.104V121.215Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M201.853 121.319C215.92 121.319 227.324 109.221 227.324 94.2967C227.324 79.3725 215.92 67.274 201.853 67.274C187.786 67.274 176.382 79.3725 176.382 94.2967C176.382 109.221 187.786 121.319 201.853 121.319Z",
    fill: "#FDB797"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M181.918 71.3907C181.918 71.3907 185.793 97.2398 227.324 93.1231L225.662 77.8484L212.376 65.4983H196.872L181.918 71.3907Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M181.918 70.8009C181.918 70.8009 185.793 96.6499 227.324 92.5333L225.662 77.2585L212.37 64.9207H196.872L181.918 70.8009Z",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M227.88 98.4072C228.798 98.4072 229.542 96.6989 229.542 94.5916C229.542 92.4843 228.798 90.776 227.88 90.776C226.962 90.776 226.218 92.4843 226.218 94.5916C226.218 96.6989 226.962 98.4072 227.88 98.4072Z",
    fill: "#FDB797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M176.382 98.4072C177.3 98.4072 178.044 96.6989 178.044 94.5916C178.044 92.4843 177.3 90.776 176.382 90.776C175.464 90.776 174.72 92.4843 174.72 94.5916C174.72 96.6989 175.464 98.4072 176.382 98.4072Z",
    fill: "#FDB797"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M256.137 34.9673C256.137 34.9673 252.813 12.0551 240.077 14.4084C227.342 16.7617 241.739 40.2575 241.739 40.2575L256.137 34.9673Z",
    fill: "#FDB797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M147.592 34.9673C147.592 34.9673 150.916 12.0551 163.652 14.4084C176.388 16.7617 161.99 40.2575 161.99 40.2575L147.592 34.9673Z",
    fill: "#FDB797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M235.479 157.81L277.178 88.4227L256.137 33.7937L241.722 39.6922L253.351 86.1002C253.351 86.1002 236.741 133.331 221.787 132.92L235.479 157.81Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M168.227 157.227L126.528 87.839L147.569 34.3835L161.967 40.2575L150.337 85.4919C150.337 85.4919 166.947 132.723 181.901 132.311L168.227 157.227Z",
    fill: "#6C63FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M225.662 178.302C225.471 179.045 228.06 179.819 227.898 180.606C226.693 186.431 226.305 193.417 226.502 201.017C227.481 238.59 242.718 291.173 243.355 293.36L244.514 293.44C244.514 293.44 228.639 239.37 227.637 201.017C227.44 193.417 227.822 186.431 229.033 180.606C229.195 179.819 229.369 179.051 229.566 178.302H225.662Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    opacity: 0.1,
    d: "M227.614 201.607L169.727 198.461C173.237 191.739 176.312 185.693 175.519 181.196C175.519 181.196 192.459 193.484 228.986 181.196C227.799 187.02 227.411 194.006 227.614 201.607Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M165.32 210.608C167.112 206.241 169.142 201.988 171.401 197.871C174.911 191.149 177.986 185.103 177.193 180.606C177.054 179.782 181.583 179.475 180.789 179.475C179.115 179.475 176.359 178.302 174.708 178.302C173.92 178.302 175.391 179.782 175.525 180.606C176.295 185.103 173.208 191.149 169.733 197.871C167.474 201.988 165.444 206.241 163.652 210.608C155.138 232.685 156.453 233.521 166.42 289.913C166.42 289.913 166.97 289.643 167.961 289.225C158.115 233.521 156.841 232.623 165.32 210.608Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M227.614 201.017L169.727 197.877C173.237 191.156 176.312 185.11 175.519 180.612C175.519 180.612 184.113 187.119 200.168 182.418C209.029 187.119 217.044 184.624 228.981 180.612C227.799 186.431 227.411 193.417 227.614 201.017Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    opacity: 0.1,
    d: "M168.355 157.448L170.845 154.216L176.104 154.511C174.69 154.393 173.269 154.594 171.933 155.1C170.597 155.606 169.378 156.406 168.355 157.448Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    opacity: 0.1,
    d: "M235.907 157.448L232.583 153.921L228.152 154.535C229.566 154.413 230.987 154.61 232.323 155.112C233.66 155.614 234.881 156.41 235.907 157.448Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    opacity: 0.1,
    d: "M206.839 265.145L209.052 265.244L209.324 264.555L206.839 264.531V265.145Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    opacity: 0.1,
    d: "M147.592 34.3774L147.864 33.4496L162.331 39.6799L161.99 40.2575L147.592 34.3774Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    opacity: 0.1,
    d: "M255.824 33.3329L241.241 39.4342L241.722 39.6676L256.12 33.7937L255.824 33.3329Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    opacity: 0.1,
    d: "M150.36 85.4857L161.99 40.2513H160.328L148.698 85.4857C148.698 85.4857 165.308 132.717 180.262 132.305H181.924C166.947 132.723 150.36 85.4857 150.36 85.4857Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    opacity: 0.1,
    d: "M253.351 86.6655L241.722 40.2575H243.396L255.025 86.6655C255.025 86.6655 238.415 133.897 223.461 133.485H221.799C236.736 133.897 253.351 86.6655 253.351 86.6655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M341.893 425.966C347.711 425.966 352.428 413.681 352.428 398.526C352.428 383.371 347.711 371.085 341.893 371.085C336.074 371.085 331.358 383.371 331.358 398.526C331.358 413.681 336.074 425.966 341.893 425.966Z",
    fill: "url(#paint1_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M380.227 432.191L303.593 431.699V430.329C303.593 415.736 314.736 412.787 328.497 412.781H355.318C369.072 412.781 380.221 415.712 380.221 430.304L380.227 432.191Z",
    fill: "url(#paint2_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M296.887 342.158L293.753 341.918C279.883 340.862 270.228 335.657 265.045 326.441C255.141 308.837 265.728 283.431 266.203 282.349L267.037 280.383H301.207L296.887 342.158ZM271.195 287.062C269.081 292.979 263.666 310.933 270.477 323.037C274.172 329.593 281.099 333.587 291.095 334.932L294.419 287.05L271.195 287.062Z",
    fill: "url(#paint3_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M385.903 342.121L381.565 280.34H415.735L416.569 282.306C417.027 283.382 427.631 308.782 417.727 326.392C412.55 335.608 402.895 340.825 389.03 341.894L385.903 342.121ZM388.347 287.013L391.712 334.889C401.708 333.538 408.629 329.538 412.324 322.975C419.135 310.865 413.696 292.918 411.577 287.001L388.347 287.013Z",
    fill: "url(#paint4_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M341.412 393.445C328.838 393.449 316.776 388.155 307.881 378.726C298.986 369.297 293.985 356.506 293.979 343.166L293.944 263.394L388.764 263.345L388.798 343.117C388.805 356.457 383.816 369.253 374.929 378.691C366.043 388.13 353.986 393.436 341.412 393.445Z",
    fill: "url(#paint5_linear_0_1)"
  }), "\r\n                        {/* ", /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M363.724 224C363.724 224 367.252 217.053 365.523 210.357C365.523 210.357 358.065 208.183 353 214.567L363.724 224Z",
    fill: "#FFE9A1"
  }), " */}\r\n                        ", /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M332 243C333.105 243 334 241.881 334 240.5C334 239.119 333.105 238 332 238C330.895 238 330 239.119 330 240.5C330 241.881 330.895 243 332 243Z",
    fill: "#2B1F0E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M341.881 423.527C347.511 423.527 352.074 411.643 352.074 396.984C352.074 382.324 347.511 370.44 341.881 370.44C336.252 370.44 331.688 382.324 331.688 396.984C331.688 411.643 336.252 423.527 341.881 423.527Z",
    fill: "#CFD8DC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M298.34 342.459L295.311 342.226C281.898 341.206 272.55 336.167 267.512 327.252C257.933 310.22 268.172 285.643 268.612 284.604L269.417 282.7H302.458L298.34 342.459ZM273.465 289.151C271.421 294.871 266.174 312.241 272.77 323.952C276.344 330.293 283.045 334.158 292.717 335.461L295.931 289.151H273.465Z",
    fill: "#CFD8DC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M384.449 342.416L380.25 282.65H413.291L414.102 284.555C414.542 285.594 424.805 310.165 415.26 327.203C410.256 336.118 400.914 341.163 387.501 342.201L384.449 342.416ZM386.812 289.108L390.067 335.424C399.733 334.115 406.434 330.244 410.001 323.897C416.592 312.18 411.328 294.822 409.277 289.096L386.812 289.108Z",
    fill: "#CFD8DC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M269.105 328.72C259.525 311.688 269.765 287.111 270.205 286.073L271.01 284.168H294.031L294.13 282.786H269.44L268.635 284.69C268.195 285.729 257.956 310.312 267.535 327.338C269.159 330.229 271.288 332.765 273.807 334.809C271.961 333.041 270.376 330.988 269.105 328.72Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    opacity: 0.05,
    d: "M387.235 282.65L388.694 282.724L388.567 289.028L387.241 289.108L387.235 282.65Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    opacity: 0.05,
    d: "M295.531 282.693H293.956V289.151H295.531V282.693Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    opacity: 0.1,
    d: "M341.852 372.382C337.01 372.382 332.962 381.18 331.925 392.971C335.04 393.664 338.213 394.012 341.395 394.01C344.887 394.019 348.369 393.607 351.773 392.781C350.719 381.07 346.682 372.376 341.852 372.382Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M295.52 266.239H387.258V343.405C387.258 349.796 386.072 356.124 383.766 362.028C381.461 367.932 378.083 373.296 373.823 377.815C369.564 382.334 364.507 385.918 358.942 388.364C353.377 390.81 347.412 392.068 341.389 392.068C329.224 392.068 317.557 386.941 308.954 377.815C300.352 368.689 295.52 356.312 295.52 343.405V266.239Z",
    fill: "#CFD8DC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    opacity: 0.1,
    d: "M299.209 343.866L299.18 266.7H295.52L295.549 343.866C295.555 356.771 300.393 369.145 308.998 378.267C317.603 387.388 329.271 392.509 341.435 392.504C342.049 392.504 342.657 392.504 343.265 392.461C331.428 391.966 320.23 386.631 312.017 377.572C303.805 368.513 299.215 356.435 299.209 343.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    opacity: 0.1,
    d: "M350.603 412.344H333.165C334.954 420.006 338.192 425.125 341.887 425.118C345.582 425.112 348.802 420.025 350.603 412.344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M378.959 430.144L304.827 430.175C304.827 417.315 314.672 413.026 326.765 413.026H356.997C369.119 413.026 378.953 417.327 378.953 430.157L378.959 430.144Z",
    fill: "#CFD8DC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    opacity: 0.1,
    d: "M331.786 410.753H328.891C315.57 410.753 304.804 416.062 304.809 430.181H307.705C307.682 416.062 318.477 410.759 331.786 410.753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M341.012 342.76C351.158 342.76 359.383 334.034 359.383 323.27C359.383 312.507 351.158 303.781 341.012 303.781C330.866 303.781 322.642 312.507 322.642 323.27C322.642 334.034 330.866 342.76 341.012 342.76Z",
    fill: "#DA552F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M343.462 313.526H334.584V333.015H338.256V327.166H343.468C345.173 327.166 346.808 326.447 348.014 325.168C349.219 323.889 349.897 322.155 349.897 320.346C349.897 318.537 349.219 316.802 348.014 315.523C346.808 314.244 345.173 313.526 343.468 313.526H343.462ZM343.462 323.27H338.25V317.415H343.462C344.193 317.415 344.895 317.723 345.412 318.272C345.929 318.82 346.219 319.564 346.219 320.34C346.219 321.115 345.929 321.859 345.412 322.408C344.895 322.956 344.193 323.264 343.462 323.264V323.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M345.188 237.041H336.182C328.186 237.041 321.703 243.918 321.703 252.402V276.948C321.703 285.432 328.186 292.309 336.182 292.309H345.188C353.185 292.309 359.667 285.432 359.667 276.948V252.402C359.667 243.918 353.185 237.041 345.188 237.041Z",
    fill: "#F9D075"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M318.779 224.646C318.779 224.646 314.47 216.357 316.584 208.425C316.584 208.425 325.688 205.838 331.867 213.427L318.779 224.646Z",
    fill: "#F9D075"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M319.066 222.383C319.066 222.383 315.863 216.239 317.433 210.316C317.433 210.316 324.203 208.393 328.802 214.039L319.066 222.383Z",
    fill: "#FFE9A1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M365.023 226C365.023 226 369.64 217.037 367.375 208.46C367.375 208.46 357.621 205.663 351 213.868L365.023 226Z",
    fill: "#F9D075"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M362.724 225C362.724 225 366.252 218.053 364.523 211.357C364.523 211.357 357.065 209.183 352 215.567L362.724 225Z",
    fill: "#FFE9A1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M367 237.003C367 237.73 366.97 238.451 366.91 239.169C365.829 252.514 354.864 263 341.5 263C329.537 263 319.493 254.598 316.742 243.254C316.248 241.21 315.999 239.107 316 236.997C316 222.643 327.419 211 341.5 211C355.581 211 367 222.664 367 237.003Z",
    fill: "#F9D075"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M319.861 249.618L317.94 245.269H310L314.482 249.43L311.249 250.561C311.249 250.561 338.026 280.799 370.559 250.561L368.043 249.618L372 246.03L369.087 245.269L370.162 243L365.821 243.189L360.814 253.012L344.115 260.768L319.861 249.618Z",
    fill: "#FFE9A1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M351 243C352.105 243 353 241.881 353 240.5C353 239.119 352.105 238 351 238C349.895 238 349 239.119 349 240.5C349 241.881 349.895 243 351 243Z",
    fill: "#2B1F0E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M367 240C365.922 252.88 354.994 263 341.675 263C329.752 263 319.742 254.891 317 243.943C318.275 245.139 319.416 246.874 320.437 248.004C321.177 248.904 322.036 249.693 322.987 250.35C324.549 251.336 326.449 251.566 328.279 251.664C329.93 251.73 331.767 251.625 332.946 250.429C334.126 249.233 334.26 247.491 334.935 246.006C335.456 244.936 336.217 244.01 337.155 243.304C338.093 242.599 339.182 242.135 340.329 241.952C342.646 241.616 345 242.211 346.903 243.614C347.419 243.962 347.864 244.408 348.217 244.929C348.584 245.649 348.886 246.404 349.116 247.183C350.588 250.863 355.345 252.341 358.934 250.869C362.524 249.397 364.902 245.684 365.789 241.807C365.954 241.038 366.305 240.079 367 240Z",
    fill: "#FFE9A1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M342.087 252L341 253.65C341.312 253.88 341.653 254 342 254C342.347 254 342.688 253.88 343 253.65L342.087 252Z",
    fill: "#F25F1D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M367 235H316V236H367V235Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M327 236H316V247H327V236Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    opacity: 0.2,
    d: "M327 236H338V238.136C338 239.956 337.371 241.702 336.251 242.989C335.131 244.277 333.612 245 332.028 245H327.006V236H327Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M315.839 235.007H317V247H315.815C315.314 247 314.818 246.891 314.355 246.679C313.892 246.468 313.471 246.157 313.117 245.766C312.763 245.375 312.482 244.911 312.29 244.4C312.099 243.888 312 243.341 312 242.787V239.213C312 238.659 312.099 238.112 312.29 237.6C312.482 237.089 312.763 236.625 313.117 236.234C313.471 235.843 313.892 235.532 314.355 235.321C314.818 235.109 315.314 235 315.815 235L315.839 235.007Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M319 252.551C319 252.551 324 254.861 324 249",
    stroke: "#2B1F0E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M347 252.551C347 252.551 342 254.861 342 249",
    stroke: "#2B1F0E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M342 249C343.105 249 344 247.881 344 246.5C344 245.119 343.105 244 342 244C340.895 244 340 245.119 340 246.5C340 247.881 340.895 249 342 249Z",
    fill: "#F25F1D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M364.376 278.736C368.578 278.736 371.986 274.36 371.986 268.961C371.986 263.562 368.578 259.185 364.376 259.185C360.173 259.185 356.765 263.562 356.765 268.961C356.765 274.36 360.173 278.736 364.376 278.736Z",
    fill: "#FFE9A1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M314.661 276.322C318.864 276.322 322.271 271.945 322.271 266.546C322.271 261.147 318.864 256.771 314.661 256.771C310.458 256.771 307.051 261.147 307.051 266.546C307.051 271.945 310.458 276.322 314.661 276.322Z",
    fill: "#FFE9A1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    opacity: 0.3,
    d: "M393.692 54.5307C393.36 54.3771 393.093 54.0995 392.942 53.7506C392.79 53.4017 392.765 53.0058 392.87 52.6383C392.888 52.5826 392.9 52.5248 392.905 52.4662C392.913 52.299 392.87 52.1334 392.784 51.9935C392.697 51.8536 392.57 51.7467 392.422 51.6884C392.274 51.6302 392.113 51.6235 391.961 51.6695C391.809 51.7154 391.675 51.8116 391.578 51.944C391.546 51.9916 391.519 52.0432 391.497 52.0976C391.353 52.4497 391.091 52.7332 390.762 52.894C390.433 53.0549 390.06 53.0819 389.714 52.9701C389.661 52.9511 389.607 52.9387 389.551 52.9332C389.394 52.9246 389.238 52.9696 389.106 53.0616C388.974 53.1537 388.873 53.2879 388.818 53.4449C388.763 53.6019 388.757 53.7734 388.8 53.9345C388.844 54.0955 388.934 54.2376 389.059 54.3402C389.104 54.3748 389.153 54.4037 389.204 54.4263C389.536 54.5799 389.803 54.8575 389.955 55.2064C390.106 55.5553 390.132 55.9512 390.026 56.3187C390.008 56.3744 389.997 56.4321 389.992 56.4907C389.983 56.658 390.026 56.8236 390.113 56.9635C390.199 57.1034 390.326 57.2103 390.474 57.2685C390.622 57.3268 390.784 57.3334 390.935 57.2875C391.087 57.2415 391.221 57.1454 391.318 57.013C391.35 56.9654 391.378 56.9138 391.399 56.8594C391.544 56.5072 391.805 56.2238 392.134 56.0629C392.463 55.9021 392.836 55.875 393.183 55.9869C393.235 56.0059 393.29 56.0183 393.345 56.0238C393.502 56.0324 393.659 55.9874 393.791 55.8954C393.922 55.8033 394.023 55.669 394.078 55.512C394.133 55.355 394.139 55.1835 394.096 55.0225C394.053 54.8615 393.962 54.7193 393.837 54.6167C393.792 54.5821 393.744 54.5532 393.692 54.5307Z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M478.591 337.439C479.921 337.439 481 336.295 481 334.883C481 333.472 479.921 332.327 478.591 332.327C477.26 332.327 476.181 333.472 476.181 334.883C476.181 336.295 477.26 337.439 478.591 337.439Z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M365.172 121.509H363.952V128.84H365.172V121.509Z",
    fill: "#47E6B1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M368.017 125.822V124.527H361.107V125.822H368.017Z",
    fill: "#47E6B1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M433.217 180.007H431.997V187.338H433.217V180.007Z",
    fill: "#47E6B1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M436.062 184.32V183.025H429.152V184.32H436.062Z",
    fill: "#47E6B1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M277.596 182.055C277.286 181.893 277.037 181.6 276.895 181.231C276.754 180.862 276.73 180.444 276.828 180.056C276.845 179.997 276.856 179.936 276.861 179.874C276.868 179.697 276.829 179.522 276.748 179.374C276.667 179.226 276.548 179.114 276.41 179.052C276.272 178.99 276.121 178.983 275.979 179.032C275.837 179.08 275.712 179.182 275.622 179.322C275.591 179.372 275.566 179.427 275.546 179.484C275.411 179.856 275.166 180.156 274.859 180.326C274.552 180.496 274.203 180.524 273.88 180.406C273.831 180.386 273.78 180.373 273.728 180.367C273.581 180.358 273.435 180.406 273.312 180.503C273.189 180.6 273.095 180.742 273.043 180.908C272.992 181.074 272.986 181.255 273.027 181.425C273.067 181.595 273.152 181.746 273.268 181.854C273.31 181.89 273.356 181.921 273.404 181.945C273.714 182.107 273.963 182.4 274.105 182.769C274.246 183.138 274.27 183.556 274.172 183.944C274.155 184.003 274.144 184.064 274.139 184.126C274.132 184.303 274.171 184.478 274.252 184.626C274.333 184.774 274.452 184.886 274.59 184.948C274.728 185.01 274.879 185.017 275.021 184.968C275.163 184.92 275.288 184.818 275.378 184.678C275.409 184.628 275.434 184.573 275.454 184.516C275.589 184.144 275.834 183.844 276.141 183.674C276.448 183.504 276.797 183.476 277.12 183.594C277.169 183.614 277.22 183.627 277.272 183.633C277.419 183.642 277.565 183.594 277.688 183.497C277.811 183.4 277.905 183.258 277.957 183.092C278.008 182.926 278.014 182.745 277.973 182.575C277.933 182.405 277.848 182.254 277.732 182.146C277.69 182.11 277.644 182.079 277.596 182.055Z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    opacity: 0.3,
    d: "M121.596 211.055C121.286 210.893 121.037 210.6 120.895 210.231C120.754 209.862 120.73 209.444 120.828 209.056C120.845 208.997 120.856 208.936 120.861 208.874C120.868 208.697 120.829 208.522 120.748 208.374C120.667 208.226 120.548 208.114 120.41 208.052C120.272 207.99 120.121 207.983 119.979 208.032C119.837 208.08 119.712 208.182 119.622 208.322C119.591 208.372 119.566 208.427 119.546 208.484C119.411 208.856 119.166 209.156 118.859 209.326C118.552 209.496 118.203 209.524 117.88 209.406C117.831 209.386 117.78 209.373 117.728 209.367C117.581 209.358 117.435 209.406 117.312 209.503C117.189 209.6 117.095 209.742 117.043 209.908C116.992 210.074 116.986 210.255 117.027 210.425C117.067 210.595 117.152 210.746 117.268 210.854C117.31 210.89 117.356 210.921 117.404 210.945C117.714 211.107 117.963 211.4 118.105 211.769C118.246 212.138 118.27 212.556 118.172 212.944C118.155 213.003 118.144 213.064 118.139 213.126C118.132 213.303 118.171 213.478 118.252 213.626C118.333 213.774 118.452 213.886 118.59 213.948C118.728 214.01 118.879 214.017 119.021 213.968C119.163 213.92 119.288 213.818 119.378 213.678C119.409 213.628 119.434 213.573 119.454 213.516C119.589 213.144 119.834 212.844 120.141 212.674C120.448 212.504 120.797 212.476 121.12 212.594C121.169 212.614 121.22 212.627 121.272 212.633C121.419 212.642 121.565 212.594 121.688 212.497C121.811 212.4 121.905 212.258 121.957 212.092C122.008 211.926 122.014 211.745 121.973 211.575C121.933 211.405 121.848 211.254 121.732 211.146C121.69 211.11 121.644 211.079 121.596 211.055Z",
    fill: "#FDD835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    opacity: 0.3,
    d: "M4.93461 279.695C4.60266 279.541 4.33549 279.264 4.18387 278.915C4.03225 278.566 4.00674 278.17 4.11221 277.803C4.13012 277.747 4.14178 277.689 4.14696 277.631C4.15508 277.463 4.11268 277.298 4.02591 277.158C3.93915 277.018 3.81257 276.911 3.66459 276.853C3.51661 276.794 3.35496 276.788 3.20317 276.834C3.05139 276.88 2.91739 276.976 2.8207 277.108C2.78808 277.156 2.76086 277.207 2.73961 277.262C2.59483 277.614 2.33314 277.897 2.00426 278.058C1.67539 278.219 1.30226 278.246 0.955815 278.134C0.903312 278.115 0.848884 278.103 0.793653 278.097C0.636016 278.089 0.4799 278.134 0.348037 278.226C0.216173 278.318 0.115445 278.452 0.060518 278.609C0.00559066 278.766 -0.000661938 278.938 0.042658 279.099C0.0859779 279.26 0.176608 279.402 0.301367 279.505C0.346278 279.539 0.394876 279.568 0.446156 279.591C0.7781 279.744 1.04528 280.022 1.1969 280.371C1.34853 280.72 1.37402 281.115 1.26856 281.483C1.25065 281.539 1.23898 281.596 1.23381 281.655C1.22569 281.822 1.2681 281.988 1.35486 282.128C1.44162 282.268 1.56821 282.375 1.71619 282.433C1.86417 282.491 2.02581 282.498 2.17759 282.452C2.32938 282.406 2.46338 282.31 2.56008 282.177C2.5927 282.13 2.61991 282.078 2.64116 282.024C2.78594 281.672 3.04764 281.388 3.37651 281.227C3.70539 281.066 4.07851 281.039 4.42496 281.151C4.47746 281.17 4.53189 281.183 4.58712 281.188C4.74476 281.197 4.90087 281.152 5.03274 281.06C5.1646 280.968 5.26532 280.833 5.32025 280.676C5.37517 280.519 5.38144 280.348 5.33812 280.187C5.2948 280.026 5.20416 279.884 5.0794 279.781C5.03449 279.746 4.98589 279.718 4.93461 279.695Z",
    fill: "#FDD835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M119.5 144C120.881 144 122 142.881 122 141.5C122 140.119 120.881 139 119.5 139C118.119 139 117 140.119 117 141.5C117 142.881 118.119 144 119.5 144Z",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M323.5 9C324.881 9 326 7.65685 326 6C326 4.34315 324.881 3 323.5 3C322.119 3 321 4.34315 321 6C321 7.65685 322.119 9 323.5 9Z",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    opacity: 0.3,
    d: "M88 41C89.6569 41 91 39.8807 91 38.5C91 37.1193 89.6569 36 88 36C86.3431 36 85 37.1193 85 38.5C85 39.8807 86.3431 41 88 41Z",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M13.5 189C14.8807 189 16 187.881 16 186.5C16 185.119 14.8807 184 13.5 184C12.1193 184 11 185.119 11 186.5C11 187.881 12.1193 189 13.5 189Z",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    opacity: 0.3,
    d: "M465.5 132C466.881 132 468 130.881 468 129.5C468 128.119 466.881 127 465.5 127C464.119 127 463 128.119 463 129.5C463 130.881 464.119 132 465.5 132Z",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M100.5 339C101.881 339 103 337.657 103 336C103 334.343 101.881 333 100.5 333C99.1193 333 98 334.343 98 336C98 337.657 99.1193 339 100.5 339Z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    opacity: 0.3,
    d: "M43 281C44.6569 281 46 279.881 46 278.5C46 277.119 44.6569 276 43 276C41.3431 276 40 277.119 40 278.5C40 279.881 41.3431 281 43 281Z",
    fill: "#47E6B1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M45.5 141C46.8807 141 48 139.881 48 138.5C48 137.119 46.8807 136 45.5 136C44.1193 136 43 137.119 43 138.5C43 139.881 44.1193 141 45.5 141Z",
    fill: "#47E6B1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    opacity: 0.98,
    d: "M22 80C23.6569 80 25 78.8807 25 77.5C25 76.1193 23.6569 75 22 75C20.3431 75 19 76.1193 19 77.5C19 78.8807 20.3431 80 22 80Z",
    fill: "#47E6B1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 200.249,
    y1: 436,
    x2: 200.249,
    y2: 11.4284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 341.871,
    y1: 426.003,
    x2: 341.851,
    y2: 371.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 341.879,
    y1: 432.245,
    x2: 341.872,
    y2: 412.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 280.991,
    y1: 342.199,
    x2: 280.969,
    y2: 280.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_1",
    x1: 401.74,
    y1: 342.154,
    x2: 401.717,
    y2: 280.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_1",
    x1: 341.379,
    y1: 393.481,
    x2: 341.331,
    y2: 263.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 481,
    height: 436,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/Complete.763b9b72f4258fbd6d69672e26f4991e.svg";
export { ForwardRef as ReactComponent };